export default /* graphql */ `
fragment link on Link {
  sys { id }
  title
  page {
    __typename
    ... on ModularPage {
      sys { id }
      slug
    }
    ... on SpecialPages	{
      sys { id }
      slug
    }
    ... on News	{
      sys { id }
      slug
    }
    ... on LiveEvent	{
      sys { id }
      slug
    }
    ... on FaqPage {
      sys { id }
      slug
    }
    ... on GalleryPage {
      sys { id }
      slug
    }
    ... on ContactPage {
      sys { id }
      slug
    }
    ... on FlightExperience {
      sys { id }
      slug
    }
    ... on PressPage {
      sys { id }
      slug
    }
    ... on PressHomepage {
      sys { id }
    }
    ... on ModularSingleEventPage {
      sys { id }
      slug
    }
    ... on ModularEventPage {
      sys { id }
      slug
    }
    ... on ModularUpcomingEvents {
      sys { id }
      slug
    }
  }
  url
  download {
    contentType
    fileName
    url
    size
  }
}
`
